import getInstanceAxios from "../../utils/request"

const baseURL =
  process.env.REACT_APP_DOMAIN ||
  (process.env.REACT_APP_API_DOMAIN
    ? `${process.env.REACT_APP_API_DOMAIN.replace(/\/$/, "")}/`
    : "/api/v1/")

export default getInstanceAxios(baseURL)
